export type ClearClickSelectionFn = () => void;

let clearClickSelection: ClearClickSelectionFn | null = null;

/**
 * `useThemePreviewHover` gọi khi attach/detach overlay.
 * Chỉ giữ một session (một shadow preview) tại một thời điểm.
 */
export function registerThemePreviewClickSelectionClear(fn: ClearClickSelectionFn | null) {
  clearClickSelection = fn;
}

/**
 * Xóa trạng thái chọn từ click HTML (`fd-selected-overlay` + observer).
 * Gọi khi đổi section sidebar hoặc tắt highlight.
 */
export function clearThemePreviewClickSelection() {
  clearClickSelection?.();
}
